if (!customElements.get('image-banner')) {
  customElements.define(
    'image-banner',
    class ImageBanner extends HTMLElement {
      connectedCallback() {
        const section = this.querySelector('[data-transparent-header="true"]');
        if (!section) return;

        document.body.classList.add('image-banner-transparent-header');

        const headerColor = section.dataset.headerColor;
        if (headerColor) {
          document.body.style.setProperty('--image-banner-header-color', headerColor);
        }
      }

      disconnectedCallback() {
        document.body.classList.remove('image-banner-transparent-header');
        document.body.style.removeProperty('--image-banner-header-color');
      }
    }
  );
}
